import { useQuery } from 'react-query'
import { getRecommendedPractitionerForSlot } from 'src/services/api/practitioners'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import { useTreatmentBundleIdForClinic } from './useTreatmentBundleIdForClinic'

export const useRecommendedPractitioner = () => {
  const config = useConfig()
  const {
    selectedBookableDateAndTime,
    treatmentBundleTypeReferenceId,
    preferredPractitionerReferenceIds,
    patientType,
    insuranceType,
  } = useChoiceState()
  const preferredPractitionerReferenceIdsString = preferredPractitionerReferenceIds.join('')
  const hasSelectedDate = !!selectedBookableDateAndTime.originalStartTimestamp
  const start = selectedBookableDateAndTime.originalStartTimestamp
  const clinicId = selectedBookableDateAndTime.clinicId || config.clinicId
  const treatmentBundleReferenceId = useTreatmentBundleIdForClinic()

  const { data, isLoading } = useQuery(
    [
      'recommendedPractitioner',
      clinicId,
      patientType,
      start,
      treatmentBundleTypeReferenceId,
      preferredPractitionerReferenceIdsString,
      treatmentBundleReferenceId,
    ],
    () =>
      getRecommendedPractitionerForSlot({
        clinicReferenceId: clinicId,
        patientType: patientType!,
        start: start!,
        treatmentBundleReferenceId,
        employeeReferenceIds: preferredPractitionerReferenceIds,
        insuranceType,
      }),
    {
      enabled:
        hasSelectedDate &&
        (preferredPractitionerReferenceIds.length > 1 || preferredPractitionerReferenceIds.length === 0), // if user selected 1 preferred practitioner then we already know which one to show
      staleTime: 900000,
    }
  )

  return { data, isLoading }
}
